import React from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';
import { Schema } from '../../../../../amplify/data/resource';
import { SelectionSet } from 'aws-amplify/api';

// Компонент для отображения статуса contribution
const ContributionStatus: React.FC<{ status: string | null | undefined }> = ({ status }) => {
  const getStatusText = () => {
    switch (status) {
      case 'ACCEPTED':
      case 'ACCEPTED_WITH_ERROR_AKA':
        return 'נקלט בהצלחה';
      case 'PROCESSING':
        return 'בתהליך';
      case 'ACTION_REQUIRED':
        return 'שגיאה';
      case 'PENDING':
        return 'ממתין';
      default:
        return '-';
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case 'ACCEPTED':
      case 'ACCEPTED_WITH_ERROR_AKA':
        return '#94C729';
      case 'PROCESSING':
        return '#808080';
      case 'ACTION_REQUIRED':
        return '#FF6F78';
      case 'PENDING':
        return '#F6B209';
      default:
        return '#808080';
    }
  };

  const statusText = getStatusText();

  // Если статус не определен или это прочерк, показываем просто прочерк
  if (statusText === '-') {
    return (
      <Typography
        fontWeight={'700'}
        fontSize={'14px'}
        fontFamily={'AlmoniDL'}
      >
        -
      </Typography>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end' }}>
      <Box
        sx={{
          width: '8px',
          height: '8px',
          minWidth: '8px',
          minHeight: '8px',
          borderRadius: '50%',
          backgroundColor: getStatusColor(),
          flexShrink: 0,
        }}
      />
      <Typography
        fontWeight={'700'}
        fontSize={'14px'}
        fontFamily={'AlmoniDL'}
        sx={{ color: '#000000' }}
      >
        {statusText}
      </Typography>
    </Box>
  );
};

const fundContributionSelectionSet = [
  'id',
  'contributionType',
  'contributionAmount',
  'contributionRate',
  'exemptPayments',
  'registryIdentifier',
  'previousRegistryIdentifier',
  'status',
  'error',
  'employeeId',
] as const;

// @ts-ignore
type FundContribution = SelectionSet<Schema['FundContribution']['type'], typeof fundContributionSelectionSet>;

interface ContributionItemProps {
  contribution: FundContribution;
}

const ContributionItem: React.FC<ContributionItemProps> = ({ contribution }) => {
  return (
    <TableRow
      sx={{
        backgroundColor: 'transparent',
        borderRadius: '10px',
        p: '20px',
        overflow: 'hidden',
        '&:last-child td, &:last-child th': { border: 0 },
        boxShadow: 'none',
        textAlign: 'right',
        verticalAlign: 'bottom',
        cursor: 'pointer',
        position: 'relative',
      }}
    >
      <TableCell
        sx={{
          py: '20px',
          px: '30px',
          borderBottom: 'none',
          borderTopRightRadius: '10px',
          borderBottomRightRadius: '10px',
        }}
      >
        <Box
          sx={{
            textAlign: 'right',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            gap: '2px',
          }}
        >
          <Typography
            fontWeight={'700'}
            fontSize={'14px'}
            fontFamily={'AlmoniDL'}
          >
            {contribution.contributionType || '-'}
          </Typography>
        </Box>
      </TableCell>

      <TableCell
        sx={{
          padding: '20px',
          borderBottom: 'none',
          textAlign: 'right',
          verticalAlign: 'bottom',
        }}
      >
        <Typography
          fontWeight={'700'}
          fontSize={'14px'}
          fontFamily={'AlmoniDL'}
        >
          -
        </Typography>
      </TableCell>

      <TableCell
        sx={{
          padding: '20px',
          borderBottom: 'none',
          textAlign: 'right',
          verticalAlign: 'bottom',
        }}
      >
        <Typography
          fontWeight={'700'}
          fontSize={'14px'}
          fontFamily={'AlmoniDL'}
        >
          {contribution.contributionAmount?.toLocaleString() || '-'}
        </Typography>
      </TableCell>

      <TableCell
        sx={{
          padding: '20px',
          borderBottom: 'none',
          textAlign: 'right',
          verticalAlign: 'bottom',
        }}
      >
        <Typography
          fontWeight={'700'}
          fontSize={'14px'}
          fontFamily={'AlmoniDL'}
        >
          {contribution.contributionRate ? `${contribution.contributionRate}%` : '-'}
        </Typography>
      </TableCell>

      <TableCell
        sx={{
          padding: '20px',
          borderBottom: 'none',
          textAlign: 'right',
          verticalAlign: 'bottom',
        }}
      >
        <ContributionStatus status={contribution.status} />
      </TableCell>

      <TableCell
        sx={{
          padding: '20px',
          borderBottom: 'none',
          textAlign: 'right',
          verticalAlign: 'bottom',
          borderTopLeftRadius: '10px',
          borderBottomLeftRadius: '10px',
        }}
      >
        <Typography
          fontWeight={'700'}
          fontSize={'14px'}
          fontFamily={'AlmoniDL'}
        >
          {contribution.error || '-'}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default ContributionItem; 